"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PRICE_OPTION = exports.PRICE_OPTION_VALUES = exports.sectionKeyToLabelKey = exports.PRICE_OPTIONS = void 0;
// eslint-disable-next-line no-shadow
var PRICE_OPTIONS;
(function (PRICE_OPTIONS) {
    PRICE_OPTIONS[PRICE_OPTIONS["LIST_PRICE"] = 1] = "LIST_PRICE";
    PRICE_OPTIONS[PRICE_OPTIONS["NO_PRICE"] = 2] = "NO_PRICE";
    PRICE_OPTIONS[PRICE_OPTIONS["DISTRIBUTOR_PRICE"] = 3] = "DISTRIBUTOR_PRICE";
    PRICE_OPTIONS[PRICE_OPTIONS["MY_PRICE"] = 4] = "MY_PRICE";
    PRICE_OPTIONS[PRICE_OPTIONS["CUSTOMER_PRICE"] = 5] = "CUSTOMER_PRICE";
    PRICE_OPTIONS[PRICE_OPTIONS["DISCOUNTED_PRICE"] = 6] = "DISCOUNTED_PRICE";
})(PRICE_OPTIONS = exports.PRICE_OPTIONS || (exports.PRICE_OPTIONS = {}));
exports.sectionKeyToLabelKey = {
    titlePage: 'title-page',
    bomTable: 'bom-table',
    isometricView: 'isometric-view',
    explodedExtrusions: 'exploded-extrusions',
    explodedComponents: 'exploded-components',
    projectDimensions: 'project-dimensions',
    panels: 'panels',
};
exports.PRICE_OPTION_VALUES = {
    [PRICE_OPTIONS.LIST_PRICE]: 'list-price',
    [PRICE_OPTIONS.NO_PRICE]: 'no-price',
    [PRICE_OPTIONS.DISTRIBUTOR_PRICE]: 'distributor-price',
    [PRICE_OPTIONS.MY_PRICE]: 'my-price',
    [PRICE_OPTIONS.CUSTOMER_PRICE]: 'customer-price',
    [PRICE_OPTIONS.DISCOUNTED_PRICE]: 'discounted-price',
};
exports.DEFAULT_PRICE_OPTION = exports.PRICE_OPTION_VALUES[PRICE_OPTIONS.LIST_PRICE];
